import { request as d } from "@nextgen-web-framework/core";
async function u(r, e) {
  e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`), e != null && e.errorHandlers && (r.errorHandlers = e.errorHandlers);
  const a = await d(r);
  return Promise.resolve(a);
}
export {
  u as handleRequest
};
//# sourceMappingURL=requestTransformer.js.map
